export function realNumberMod(number, modulus) {
  if (number >= 0) {
    return number % modulus;
  }

  while (number < 0) {
    number += modulus;
  }

  return number;
}
